// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"625b5c41","796":"625b5c41","931":"625b5c41","941":"fbbb44d1","953":"1e702dee","975":"5dfc8bd8"}[chunkId] + ".chunk.css";
};